module.exports = __webpack_public_path__ + "img/mentalvideolock.1b2991d3.png";